import { QuoteResponse } from './types';
import { PayloadAction } from '@reduxjs/toolkit';

export const reducers = {
  getQuoteInformationData(state) {
    state.isLoading = true;
  },
  getQuoteInformationSuccess(state, action: PayloadAction<QuoteResponse>) {
    state.data = action.payload;
    state.error = null;
  },
  getQuoteInformationFail(state, action: PayloadAction<unknown>) {
    state.data = null;
    state.error = action.payload;
  },
};
